import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import ReportService from "services/ReportService";

export const initialState = {
  data: null,
  loading: false,
  error: null,
  redirect: false,
};

export const fetchReportData = createAsyncThunk(
  "report/fetchReportData",
  async (data, { rejectWithValue }) => {
    try {
      const {
        type,
        outlet,
        date,
        date_from,
        date_to,
        district,
        type_filter,
        status,
        inv,
      } = data;
      const response = await ReportService.get({
        type,
        outlet,
        district,
        date,
        date_from,
        date_to,
        type_filter,
        status,
        inv,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    resetDataReport: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { showLoading, resetDataReport } = reportSlice.actions;

export default reportSlice.reducer;
